// Settings > Account and backup > Beta: a way into /beta for accounts that are in the beta.
//
// The row starts hidden and only shows once the server says this account is in (see
// shared/beta-access.js). Signed out, signed in as someone else, or any doubt: it stays hidden.
// /beta can't be shown inside a frame, so it opens in a new browser tab.
import { onAccountChange } from "../../app/account.js";
import { cachedBetaMember, checkBetaMember } from "../../shared/beta-access.js";

// Show or hide the row, and its group heading with it.
export function showBetaRow(control, on) {
	const r = control.closest(".rv-row");
	if (!r) return;
	r.dataset.empty = on ? "" : "1";
	r.hidden = !on;
	const g = r.closest(".rv-grp");
	if (g) g.hidden = ![...g.querySelectorAll(".rv-section-body > .rv-row")].some((x) => !x.hidden);
}

export function betaEntryControl() {
	const a = document.createElement("a");
	a.className = "rv-btn rv-btn-primary";
	a.href = "/beta";
	a.target = "_blank";
	a.rel = "noopener";
	a.textContent = "Open beta";
	a.dataset.empty = cachedBetaMember() === true ? "" : "1";
	let gen = 0;
	const update = (fresh) => {
		const my = ++gen;
		checkBetaMember({ fresh }).then((on) => { if (my === gen) showBetaRow(a, on); });
	};
	// the row isn't in the page yet when this runs
	queueMicrotask(() => update(false));
	onAccountChange(() => { showBetaRow(a, false); update(true); });
	return a;
}
